import React, { useState, useRef } from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';
import { CommonPickerMethods } from 'antd/es/date-picker/generatePicker/interface';
import { ArrowRightOutlined } from '@ant-design/icons';
import { getLocalTime } from '@components/overview-dashboard/overview-date-picker/dateUtils';

const { RangePicker } = DatePicker;

const CustomDateRangePicker = ({
  overviewDate,
  tzOffset,
  containerRef,
  setDateCb,
  selectedInterval,
}) => {
  const [open, setOpen] = useState(false);
  const refRangePicker = useRef<CommonPickerMethods>(null);
  const allowedDateMoment = moment(getLocalTime(overviewDate, tzOffset));

  const onCustomSelection = (interval) => {
    if (!interval[0] || !interval[1]) return;
    const currentInterval = {
      from: moment(interval[0]).format(),
      to: moment(interval[1]).format(),
      shortcut: 'custom',
    };

    // dispatch(setInterval({interval: currentInterval}));
    setOpen(false);
    setTimeout(() => {
      if (refRangePicker.current) {
        refRangePicker.current?.blur();
      }
      setDateCb(currentInterval, 'datepicker');
    }, 2);
  };

  const disableDates = (calendarDate) => {
    const calendarDateMoment = moment(calendarDate);
    return (
      moment().isBefore(calendarDateMoment) ||
      calendarDateMoment.isBefore(allowedDateMoment) ||
      calendarDateMoment.isBefore(moment().subtract(13, 'months').startOf('day'))
    );
  };

  return (
    <RangePicker
      ref={refRangePicker}
      open={open}
      style={{
        width: '370px',
      }}
      transitionName={''}
      value={[moment(selectedInterval.from) as any, moment(selectedInterval.to)] as any}
      disabledDate={disableDates}
      onOpenChange={(open) => {
        setOpen(open);
      }}
      separator={<ArrowRightOutlined />}
      onChange={onCustomSelection}
      showTime={{
        defaultValue: [
          moment('00:00:00', 'HH:mm:ss') as any,
          moment('23:59:59', 'HH:mm:ss') as any,
        ],
      }}
      // getCalendarContainer={() => containerRef.current} /* tslint:disable-line */
    />
  );
};

export default CustomDateRangePicker;
